class ResursbankController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'Shops'
		'IntegrationRepository'

	integrationId: 'resursbank'

	initialize: ->
		@shops = @Shops.data

		if _.isEmpty(@configuration.shops)
			@configuration.shops = {}

		@sanitizeShopMappings()

	save: ->
		if @configuration.credentials?.client_secret == ''
			delete @configuration.credentials.client_secret

		if @configuration.credentials?.client_id == ''
			delete @configuration.credentials.client_id

		super(@configuration)
			.then (response) =>
				@configuration = response.data
				@sanitizeShopMappings()
				@updateConfigurationOptions()

	afterDisconnect: ->
		@configuration = {}

	sanitizeShopMappings: () ->
		if _.isEmpty(@configuration.shops)
			@configuration.shops = {}
			return

		for key, value of @configuration.shops
			@configuration.shops[key] = parseInt(value)

	updateConfigurationOptions: ->
		@IntegrationRepository
			.getConfigurationOptions @integrationId
			.then (response) =>
				@configurationOptions = response.data
